import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.o5g().l50() : headers;
  return DelegatedCall().i5i(_this__u8e3s4.j5g_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      static i5i(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.o5g().l50() : responseHeaders;
        var $this = this.j5i(client);
        $this.l5g_1 = new (DelegatedRequest())($this, originCall.k5i());
        $this.m5g_1 = new (DelegatedResponse())($this, originCall.o5g(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.p5i_1 = origin;
        this.q5i_1 = call;
      }
      r5i() {
        return this.q5i_1;
      }
      ew() {
        return this.p5i_1.ew();
      }
      s5i() {
        return this.p5i_1.s5i();
      }
      t5i() {
        return this.p5i_1.t5i();
      }
      l5i() {
        return this.p5i_1.l5i();
      }
      t2o() {
        return this.p5i_1.t2o();
      }
      l50() {
        return this.p5i_1.l50();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.l50() : headers;
        super();
        this.u5i_1 = call;
        this.v5i_1 = origin;
        this.w5i_1 = content;
        this.x5i_1 = headers;
        this.y5i_1 = this.v5i_1.ew();
      }
      r5i() {
        return this.u5i_1;
      }
      l50() {
        return this.x5i_1;
      }
      z5i() {
        return this.w5i_1(this.v5i_1);
      }
      ew() {
        return this.y5i_1;
      }
      a5j() {
        return this.v5i_1.a5j();
      }
      b5j() {
        return this.v5i_1.b5j();
      }
      c5j() {
        return this.v5i_1.c5j();
      }
      d5j() {
        return this.v5i_1.d5j();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
